/**
 * Utility functions for file icons and colors
 */
import { ASSET_BASE_URL } from '../config/constants';

/**
 * Get icon path based on file extension
 * @param {string} extension - File extension (without dot)
 * @returns {string|null} Icon path or null if no icon available
 */
export function getFileIcon(extension) {
  switch (extension) {
    case 'py':
      return `${ASSET_BASE_URL}/icons/Python-logo-notext.svg`;
    default:
      return null;
  }
}

/**
 * Get color for file extension
 * @param {string} extension - File extension (without dot)
 * @returns {string} Hex color code
 */
export function getExtensionColor(extension) {
  const colorMap = {
    // JavaScript/TypeScript
    'js': '#f7df1e',
    'jsx': '#61dafb',
    'ts': '#3178c6',
    'tsx': '#3178c6',
    // HTML/CSS
    'html': '#e34c26',
    'css': '#264de4',
    'scss': '#cc6699',
    'sass': '#cc6699',
    // Python
    'py': '#3776ab',
    'pyw': '#3776ab',
    // Java
    'java': '#ed8b00',
    // C/C++
    'c': '#00599c',
    'cpp': '#00599c',
    'h': '#00599c',
    'hpp': '#00599c',
    // JSON/Data
    'json': '#22c55e',
    'xml': '#ff6600',
    'yaml': '#cb171e',
    'yml': '#cb171e',
    // Markdown
    'md': '#083fa1',
    'markdown': '#083fa1',
    // Shell
    'sh': '#89e051',
    'bash': '#89e051',
    'zsh': '#89e051',
    // SQL
    'sql': '#336791',
    // Go
    'go': '#00add8',
    // Rust
    'rs': '#000000',
    // PHP
    'php': '#777bb4',
    // Ruby
    'rb': '#cc342d',
    // Swift
    'swift': '#fa7343',
    // Kotlin
    'kt': '#7f52ff',
    // Default
    'default': '#666666'
  };
  
  return colorMap[extension] || colorMap['default'];
}
